<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" :color="color" :class="`${icon} icon`" small>{{ icon }}</v-icon>
    </template>
    {{ description }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'IconTooltip',

  props: {
    icon: {
      type: String,
      required: true,
    },

    color: {
      type: String,
      default: 'black',
    },

    description: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.icon {
  font-style: normal;
  text-transform: uppercase;
}

.icon.cnae {
  font-size: 12px !important;
  font-weight: 600 !important;
}
</style>
